import axios from "axios";

const API_URL = `${process.env.REACT_APP_BACKEND_URL}/api/auth`;

// Register a new user
export const registerUser = async (
    firstName,
    lastName,
    email,
    username,
    password,
    confirmPassword,
    role,
) => {
    try {
        const response = await axios.post(`${API_URL}/register`, {
            first_name: firstName,
            last_name: lastName,
            email,
            username,
            password,
            confirm_password: confirmPassword,
            role,
        });
        return response.data;
    } catch (error) {
        return { error: error.response?.data?.error || "Registration failed" };
    }
};

// Log in a user
export const loginUser = async (username, password) => {
    try {
        const response = await axios.post(
            `${API_URL}/secure-login`,
            {
                username,
                password,
            },
            {
                // This tells axios to accept cookies
                withCredentials: true,
            },
        );

        return response.data;
    } catch (error) {
        const responseData = error.response?.data || {};
        return {
            ...responseData,
            error: responseData.error || "Login failed",
            code: responseData.code || null,
        };
    }
};

export const resendVerificationEmail = async(identifier) => {
    try {
        const response = await axios.post(`${API_URL}/resend-verification`, {
            identifier,
        });
        return response.data;
    } catch(error) {
        const responseData = error.response?.data || {};
        return {
            ...responseData,
            error:
                responseData.error ||
                "Unable to resend the verification email.",
        };
    }
};

// Get the currently logged-in user's data
export const getLoggedInUser = async () => {
    try {
        const response = await axios.get(`${API_URL}/user`, {
            withCredentials: true,
        });

        return response.data;
    } catch (error) {
        console.log(error);
        // Return `null` if no user is logged in
        return null;
    }
};